// extracted by mini-css-extract-plugin
export default {"container":"PhotoList_styles_container__qO9Dl","image":"PhotoList_styles_image__G7C9o"};